import { Topology } from '../../../../../services/eventingApi';
import OverviewKpis from './OverviewKpis';
import ProducersCard from './ProducersCard';
import SubscriptionsCard from './SubscriptionsCard';

interface OverviewTabProps {
  topology: Topology;
  onOpenConsumer: (consumer: string) => void;
}

const OverviewTab = ({ topology, onOpenConsumer }: OverviewTabProps) => (
  <div className="space-y-4">
    <OverviewKpis topology={topology} />
    <ProducersCard outbox={topology.outbox} />
    <SubscriptionsCard topology={topology} onOpenConsumer={onOpenConsumer} />
  </div>
);

export default OverviewTab;
